module.exports = __webpack_public_path__ + "606207f39c4043c11036863e1690790a.svg";